import axiosInstance from "./axiosConfig";
import ApiConfig from "./config";

export const getTransactions = async (payload) => {
  const response = await axiosInstance.put(
    ApiConfig.ENDPOINTS.GET_SUMMARY_BY_TRANSACTION,
    payload
  );
  return response.data;
};